import api from 'api';
import { httpErrorTypes, errorActions } from 'utility/error';

export const UPLOAD_AR_FILE_REQUEST = 'UPLOAD_AR_FILE_REQUEST';
export const UPLOAD_AR_FILE_SUCCESS = 'UPLOAD_AR_FILE_SUCCESS';
export const UPLOAD_AR_FILE_FAILURE = 'UPLOAD_AR_FILE_FAILURE';
export const UPLOAD_STOP_GO_PROGRAMS_REQUEST = 'UPLOAD_STOP_GO_PROGRAMS_REQUEST';
export const UPLOAD_STOP_GO_PROGRAMS_SUCCESS = 'UPLOAD_STOP_GO_PROGRAMS_SUCCESS';
export const UPLOAD_STOP_GO_PROGRAMS_FAILURE = 'UPLOAD_STOP_GO_PROGRAMS_FAILURE';
export const CLEAR_UPLOAD = 'CLEAR_UPLOAD';

export const clearUploadState = () => ({
  type: CLEAR_UPLOAD
});

export const uploadARFile = file => ({
  types: [UPLOAD_AR_FILE_REQUEST, UPLOAD_AR_FILE_SUCCESS, UPLOAD_AR_FILE_FAILURE],
  callAPI: (state, { customerId, userId }) =>
    api.postWithFile(`invoicereferencesvc/v0/cust/${customerId}/user/${userId}/uploadARfile`, file),
  httpErrorTypes,
  successDisplayType: 'toast'
});

export const uploadStopGoProgram = () => ({
  types: [UPLOAD_STOP_GO_PROGRAMS_REQUEST, UPLOAD_STOP_GO_PROGRAMS_SUCCESS, UPLOAD_STOP_GO_PROGRAMS_FAILURE],
  callAPI: (state, { customerId, userId }) => api.fetch(`stopgosvc/v0/cust/${customerId}/user/${userId}/stopgofilters`),
  httpErrorTypes,
  errorDisplayType: 'modal'
});
